import React, {useContext, useEffect, useState} from "react";
import {
    Alert,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Fade,
    FormControlLabel,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import {Link} from "react-router-dom";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowRight01Icon, GoogleIcon} from "@hugeicons/core-free-icons";
import {toast} from "react-toastify";
import {SignInContext} from "../../../context/SignInContext";
import {mapToUrl} from "../../../utils/functions";
import {c, mono, primaryButtonSx} from "../../landing/landingTokens";
import {AuthLayout} from "../components/AuthLayout";
import {AuthPasswordField} from "../components/AuthPasswordField";
import {fieldSx} from "../components/authStyles";

export const LoginPage = () => {
    const [loginWithMail, setLoginWithMail] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const {onLogin} = useContext(SignInContext);
    const [showRegistrationMessage, setShowRegistrationMessage] = useState(false);

    useEffect(() => {
        const registrationSuccess = sessionStorage.getItem("registration_success");

        if (registrationSuccess === "true") {
            setShowRegistrationMessage(true);
            sessionStorage.removeItem("registration_success");
        }
    }, []);

    const loginHandle = async (e) => {
        e.preventDefault();
        if (!loginWithMail) {
            setLoginWithMail(true);
            return;
        }
        try {
            setLoading(true);
            await onLogin({username: email, password: password});
        } catch (err) {
            if (err.code === "PASSWORD_SETUP_REQUIRED") toast.info(err.message);
            else toast.error(err.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <AuthLayout
            title={"Sign in"}
            prompt={"Don't have an account yet?"}
            linkText={"Sign up"}
            linkTo={"/register"}
            banner={showRegistrationMessage && (
                <Alert
                    severity="info"
                    sx={{
                        width: "100%",
                        color: c.ink,
                        bgcolor: "rgba(129, 140, 248, 0.07)",
                        boxShadow: "0 6px 18px rgba(129, 140, 248, 0.10)",
                        "& .MuiAlert-icon": {color: c.purpleDeep},
                    }}
                >
                    You're all set! We've sent a verification link to your email. Please verify your account before signing in.
                </Alert>
            )}
        >
            {/*LOGIN WITH MAIL*/}
            <Stack component={"form"} onSubmit={loginHandle} direction={"column"} gap={0.5} sx={{width: '100%'}}>
                <TextField
                    variant={"filled"}
                    required
                    fullWidth
                    label={"Email"}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder={"Enter your email address"}
                    helperText={" "}
                    sx={fieldSx}
                />
                {
                    loginWithMail &&
                    <Fade in={loginWithMail}>
                        <AuthPasswordField
                            autoFocus
                            required
                            label={"Password"}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder={"Password"}
                            helperText={" "}
                        />
                    </Fade>
                }

                <Stack direction={"row"} gap={2} justifyContent={"space-between"} alignItems={"center"}
                       useFlexGap flexWrap={"wrap"}>
                    <FormControlLabel sx={{color: c.inkSoft}} control={<Checkbox defaultChecked
                                                                                 sx={{"&.Mui-checked": {color: c.purpleDeep}}}/>}
                                      label="Remember me"/>
                    <Typography sx={{textDecoration: "none", color: c.inkSoft, fontSize: 14}}
                                component={Link}
                                to={"/forgot-password"}>Forgot password?</Typography>
                </Stack>

                <Button
                    fullWidth
                    type={"submit"}
                    disabled={loading || (!loginWithMail && !email)}
                    sx={{...primaryButtonSx, py: 1.4, fontSize: 15, mt: 1}}
                    endIcon={loading
                        ? <CircularProgress size={16} color={"inherit"}/>
                        : <HugeiconsIcon icon={ArrowRight01Icon} size={13}/>}
                >
                    {loginWithMail ? "Log in" : "Continue"}
                </Button>

                <Box sx={{
                    textAlign: "center", color: c.inkMuted, fontFamily: mono, fontSize: 11,
                    letterSpacing: "0.14em", py: 1
                }}>
                    OR
                </Box>
                <Button
                    component={'a'}
                    href={mapToUrl(`/api/auth/oauth2/google?redirect_uri=${encodeURIComponent(`${window.location.origin}/oauth2/redirect`)}`, process.env.REACT_APP_USERMANAGEMENT_GATEWAY)}
                    fullWidth
                    startIcon={<HugeiconsIcon icon={GoogleIcon}/>}
                    sx={{
                        borderRadius: "980px", textTransform: "none", fontWeight: 500, fontSize: 14,
                        py: 1.25, color: c.ink, bgcolor: "rgba(20,21,26,0.04)",
                        "&:hover": {bgcolor: "rgba(129,140,248,0.10)"}
                    }}
                >
                    Continue with Google
                </Button>
            </Stack>
        </AuthLayout>
    )
}
